import type { ComponentProps } from "react";

// Express the product as visible additions and spending resolving to a total.
export function Logo(props: ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        height="25"
        rx="6"
        stroke="currentColor"
        strokeWidth="1.8"
        width="25"
        x="1.5"
        y="1.5"
      />
      <path d="M7.5 8.5h5M10 6v5" stroke="currentColor" strokeWidth="1.8" />
      <path d="M16 8.5h4.5" stroke="currentColor" strokeWidth="1.8" />
      <path d="M7.5 16h13" stroke="currentColor" strokeWidth="1.8" />
      <path d="M12 21h8.5" stroke="currentColor" strokeWidth="2.2" />
    </svg>
  );
}
